import React, { FC } from 'react';
import { useStore } from '../../../store/store-provider';
import { observer } from 'mobx-react';
import { DragDropContext, Droppable, DropResult, } from 'react-beautiful-dnd';
import { getNewPrioritize, sortByPrioritize } from '../../../utils/helpers/prioritize-helpers';
import { getGMTDate } from '../../../utils/helpers/date-helper';
import { QandaTabs } from '../../../constans/question-enums';
import QuestionActionForm from './question-action-form/question-action-form';

import QuestionEntity from '../../../store/question-store/question-entetiy';
import { DraggableQuestionWrapper } from './question-card-container/dragable-question-wrapper';
import { NonceCSP } from '../../../constans/common-constants';

interface IProps {
    questions: QuestionEntity[];
    title?: string;
    subTitle?: string;
    numberOfNewQuestions?: number;
}

const QuestionsContainer: FC<IProps> = observer(({
  questions,
  title = '',
  numberOfNewQuestions
}) => {
  const { questionStore, podiumInfoStore } = useStore();
  const { isShowCreateQuestion, setShowCreateQuestion } = questionStore;
  const { isReviewMode } = podiumInfoStore;
  const { updateQuestion, isDisabled, editableQuestionId, setEditableQuestionState } = questionStore;
  const copyQuestions = sortByPrioritize([...questions]) as QuestionEntity[];

  const reorder = (startIndex: number, endIndex: number) => {
    if(startIndex === endIndex) return;
    const prioritize = getNewPrioritize({
      startIndex,
      endIndex,
      list: copyQuestions
    });

    copyQuestions[startIndex].prioritizeIndex = prioritize;
    updateQuestion(copyQuestions[startIndex].messageId, copyQuestions[startIndex].state, getGMTDate(), prioritize);
  };

  const onDragEndHandler = (result: DropResult): void => {
    const { source, destination } = result;
    if (!destination) return;
    reorder(
      source.index,
      destination.index
    );
  };

  return (
    <div className="wrapper">
      <div className="question-container bg-white">
        <div className="question-title-list">
          <h4>{`${title} Questions  (${questions.length})`}
            {!!numberOfNewQuestions && (
              <span id="new-question-label-wrapper">
                { numberOfNewQuestions }<span>New</span>
              </span>
            )}
            {title === QandaTabs.UNANSWERED &&
              <span
                className="create-question"
                data-disabled={ isShowCreateQuestion }
                onClick={() => !isShowCreateQuestion && setShowCreateQuestion(true)}
              >
                Create Question
              </span>}
          </h4>
        </div>
        {title === QandaTabs.UNANSWERED && isShowCreateQuestion && <QuestionActionForm setEditableQuestionState={setEditableQuestionState}/>}
        <DragDropContext onDragEnd={onDragEndHandler} nonce={NonceCSP.DND}>
          <div className="list-items">
            <Droppable droppableId="items">
              {(provided, snapshot) => (
                <ul className="unanswered-questions" ref={provided.innerRef}>
                  {copyQuestions.length ?
                    copyQuestions.map((question: QuestionEntity, index) =>
                      <DraggableQuestionWrapper
                        key={question.messageId}
                        question={question}
                        index={index}
                        updateQuestion={updateQuestion}
                        isDisabled={isDisabled}
                        isReviewMode={isReviewMode}
                        editableQuestionId={editableQuestionId}
                        setEditableQuestionState={setEditableQuestionState}
                      />
                    )
                    : null}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </div>
        </DragDropContext>
      </div>
    </div>
  );
});

export default QuestionsContainer;
